import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { TDurationGroupInfo, TFilterGroupModel, TOrgFilter, TSelectFilterGroupInfo } from '../model/ui-filter.types';
import { UiFilterModifiers } from '../model/ui-filter.modifier';
import { cloneDeep } from 'lodash';
import { TSelectedHeirarchy } from '../../org-heirarchy/org-heirarchy.component';

export type TFilterModalDismissEmitVal<T> =
  | {
      role: 'cancel';
      data: null;
    }
  | {
      role: 'apply';
      data: TFilterGroupModel<T>;
    };

@Component({
  selector: 'monorepo-filter-modal',
  templateUrl: './filter-modal.component.html',
  styleUrls: ['./filter-modal.component.scss'],
})
export class FilterModalComponent<T> {
  @Input() filterModel!: TFilterGroupModel<T>;
  @Input() onFilterTabChange!: (x: TFilterGroupModel<T>) => Promise<TFilterGroupModel<T>>;

  constructor(private modalCtrl: ModalController) {}
  activeFilterIdx = 0;
  cancel() {
    return this.modalCtrl.dismiss(null, 'cancel');
  }

  confirm() {
    const sanatizeFilterModel = UiFilterModifiers.sanitaize(this.filterModel);
    return this.modalCtrl.dismiss(sanatizeFilterModel, 'apply');
  }

  activeFilter(index: number) {
    if (index !== this.activeFilterIdx) {
      this.onFilterTabChange(this.filterModel).then((res) => {
        this.filterModel = cloneDeep(res);
      });
    }

    this.activeFilterIdx = index;
  }

  updatedModel($event: TSelectFilterGroupInfo['items'] | TDurationGroupInfo['items'], index: number) {
    console.log('updatedModel', $event);
    switch (this.filterModel.groups[index].type) {
      case 'SELECT_FILTER': {
        const updatedGroup = {
          ...this.filterModel.groups[index],
          items: $event,
        } as TSelectFilterGroupInfo;
        this.filterModel.groups.splice(index, 1, updatedGroup);
        break;
      }
      case 'DURATION_FILTER': {
        const updatedGroup = {
          ...this.filterModel.groups[index],
          items: $event,
        } as TDurationGroupInfo;
        this.filterModel.groups.splice(index, 1, updatedGroup);
        break;
      }
    }
    console.log(this.filterModel.groups[index]);
    this.filterModel = UiFilterModifiers.sanitaize(this.filterModel);
  }

  orgHeirarchySelectionEmitter($event: TSelectedHeirarchy, index: number) {
    console.log('updatedModel', $event);

    const updatedGroup = {
      ...this.filterModel.groups[index],
      filteredOrgTree: $event.payload,
      leafNodesSelected: $event.leafNodesSelected,
    } as TOrgFilter;
    this.filterModel.groups.splice(index, 1, updatedGroup);
    console.log(this.filterModel.groups[index]);
    this.filterModel = UiFilterModifiers.sanitaize(this.filterModel);
  }

  trackByFn(index: number, group: TFilterGroupModel<T>['groups'][number]) {
    return group.key;
  }

  clearFilter() {
    this.filterModel = UiFilterModifiers.removeAllFilterValue(this.filterModel);
  }
}
